import store from '@/common/stores/store'
import { OPPORTUNITY_CENTER } from '@/features/opportunity-center/beta-features'

export const isOpportunityCenterEnabled = (): boolean => {
  return store.getters.hasBetaFeature(OPPORTUNITY_CENTER)
}
